import { useRef, useEffect, useCallback } from "react";
import isEqual from "fast-deep-equal";
/**
 * useMountedState
 */
export function useMountedState() {
    var mountedRef = useRef(false);
    var getMounted = useCallback(function () { return mountedRef.current; }, []);
    useEffect(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    });
    return getMounted;
}
/**
 * useDeepMemo
 * @param value
 */
export function useDeepMemo(value) {
    var ref = useRef(value);
    if (!isEqual(ref.current, value)) {
        ref.current = value;
    }
    return ref.current;
}
/**
 * useRefFn
 * @param fn
 */
export function useRefFn(fn) {
    var refFn = useRef(fn);
    useEffect(function () {
        refFn.current = fn;
    }, [fn]);
    return refFn;
}
/**
 *
 * @param strOrFn
 * @param args
 * @returns string | number | undefined
 */
export function getStrByFn(strOrFn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof strOrFn === "function") {
        return strOrFn.apply(void 0, args);
    }
    return strOrFn;
}
